// extracted by mini-css-extract-plugin
export default {"button":"Legend_button__eynYe","legend":"Legend_legend__cLI8i"};